import { render } from "./DashUserGeneric.vue?vue&type=template&id=524ebb0a&scoped=true&ts=true"
import script from "./DashUserGeneric.vue?vue&type=script&lang=ts"
export * from "./DashUserGeneric.vue?vue&type=script&lang=ts"

import "./DashUserGeneric.vue?vue&type=style&index=0&id=524ebb0a&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524ebb0a"]])

export default __exports__